export const SUPABASE_URL = 'https://gyvwswzqsznkbsnvivrw.supabase.co';
export const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd5dndzd3pxc3pua2JzbnZpdnJ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTg2ODA3NTMsImV4cCI6MjAzNDI1Njc1M30.t9FluvpQbzqPxyqIEgh3R3yCUPbKEYNoOdPOCqfSLnA';
